/**
 * "Log ind, og kom tilbage hertil" — the one spelling of the login redirect.
 *
 * `/login` honours `?redirect=` (and `middleware.ts` mints the same shape when
 * it bounces a signed-out browser), so every "Log ind" link a screen draws
 * must carry the page the reader was on. This helper is that expression;
 * before it, the template literal was copy-pasted per call site, which is one
 * typo away from a login that lands on the feed instead of back where the
 * reader was.
 *
 * `redirectTo` is a PATHNAME (`usePathname()`, or a path built from route
 * params) — not a full URL, which `/login`'s open-redirect guard ignores in
 * favour of `/feed`.
 */
export function loginHref(redirectTo: string): string {
  return `/login?redirect=${encodeURIComponent(redirectTo)}`;
}
